interface AddressTypeData {
  id?: number;
  name?: string;
  isDefault?: boolean;
}

export class AddressType {
  public static readonly ID_HOME: number = 1;
  public static readonly ID_INVOICE: number = 2;

  public static readonly ID_DEFAULT: number = AddressType.ID_HOME;

  public static getNonTranslatableFields(): string[] { return ['id', 'isDefault']; }
  public static getTranslatableFields(): string[] { return ['name']; }
  public static getFields(): string[] { return ['id', 'name', 'isDefault']; }
  public static getKeyFields(): string[] { return ['id']; }


  id?: number;
  name?: string;
  isDefault?: boolean;

  public static fromAPI(data: AddressTypeData): AddressType {
    return new AddressType(data);
  }

  public static fromAPIList(data: AddressTypeData[]): AddressType[] {
    return data.map((item: AddressTypeData) => AddressType.fromAPI(item));
  }

  constructor({id, name, isDefault} : AddressTypeData) {
    this.id = id;
    this.name = name;
    this.isDefault = isDefault;
  }

  public toJson(): Object {
    return {
      id: this.id,
      name: this.name,
      isDefault: this.isDefault
    };
  }
}
